<template>
  <div
    v-if="news.length != 0"
    id="news"
  >
    <div class="container">
      <div class="flag">
        <span class="title">
          <span style="margin-bottom:-20px;">熱門</span><br><span>消息</span>
        </span>
      </div>
      <div class="newsWrap">
        <div
          v-for="(newItem, index) in news"
          :key="index"
          class="news"
        >
          <div class="wrap">
            <span class="date">{{ newItem.Start.substr(0,10) }}</span>
            <span
              class="nav_title"
              @click="goPage(newItem.Url)"
            >
              {{ newItem.Title }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { googleFormTransform } from '@/js/utils'
export default {
  data () {
    return {
      news: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      const res = await this.$getAPI(`${process.env.VUE_APP_CORE_URL}/api/News/GetNews`)
      const arrangeData = res.News.sort((a, b) => {
        return Date.parse(b.Start) - Date.parse(a.Start)
      })
      this.news = arrangeData.map(el => {
        const processedUrl = googleFormTransform.fetchURL(el.Url)
        return {
          ...el,
          Url: processedUrl
        }
      })
    },
    goPage (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
#news
  background-color: $bgDarkBg
  border-radius: 8px
  margin-bottom: 20px
  .container
    display: flex
    min-height: 173px
  .news
    margin-bottom: 20px
    margin-left: 20px
    font-size: 23px
    &:last-child
     margin-bottom: 0px
  .date
    margin-right: 10px
    letter-spacing: 1px
  .wrap
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    width: 99%
  .nav_title
    text-decoration: underline
    &:hover
      cursor: pointer
      color: #000
  .flag
    width: 153px
    background-color: $mainColor
    display: flex
    justify-content: center
    align-items: center
    border-radius: 8px 0px 0px 8px
    .title
      color: $white
      font-size: 29px
      span
        display: block
  .newsWrap
    margin: 30px 0px
    width: 742px
</style>
